export default {
  expoName: "Личный кабинет",
  expoNameManager: "Личный кабинет менеджера",
  expoBrandName: "ЭКСПОцентр",

  email: "Электронная почта",
  password: "Пароль",
  repeatPassword: "Повторите пароль",
  lastName: "Фамилия",
  firstName: "Имя",
  middleName: "Отчество",
  phone: "Контактный телефон",
  jobPosition: "Ваша должность",
  companyName: "Название компании",
  companyWebsite: "Сайт компании",
  birthday: "Дата рождения",
  birthplace: "Место рождения",
  requiredFields: "Обязательные поля",

  header: {
    myExhibitions: "Мои выставки",
    support: "Поддержка",

    profileEdit: "Редактировать профиль",
    profileLogout: "Выйти из личного кабинета"
  },

  footer: {
    helplineOpenHours: "ежедневно с 08.00 до 20.00",
    callbackRequest: "Заказать звонок",
    privatePolicy: "Политика обработки персональных данных в АО «ЭКСПОЦЕНТР»"
  },

  addEventBtn: "Добавить выставку",
  contactUsBtn: "Напишите нам",

  addEventCardGo: "Перейти к выставке",

  eventCardGo: "Перейти",
  eventCardLook: "Посмотреть",

  addBtn: "Добавить",
  addingBtn: "Добавление...",
  addedBtn: "Добавлена",

  saveBtn: "Сохранить",
  savingBtn: "Сохранение...",
  savedBtn: "Сохранено",

  editBtn: "Редактировать",
  fillBtn: "Заполнить",
  lookBtn: "Просмотреть",

  submitBtn: "Отправить",
  selectBtn: "Выбрать",

  cancelBtn: "Отменить",
  cancel: "Отмена",
  deleteBtn: "Удалить",
  closeBtn: "Закрыть",
  ok: "ОК",

  validationError: "Заполнены не все поля",

  addMore: "Добавить еще",

  loading: "Загрузка...",

  inn: "ИНН",
  notFoundPage: " К сожалению, такой страницы не существует",
  goToExhib: "На главную",
  error: "Произошла тех. ошибка на сервере.",
  errorFront: "Произошла ошибка, попробуйте заново"
};
